module.exports = __webpack_public_path__ + "pl.f6afdb62.svg";